<div class="add-group-container group-assignment-container">
  <div class="groups-to-assign">
    <h5 class="group-title">
      {{ 'organization.users.invite.groupView.selectGroup' | transloco }}
    </h5>

    <div data-cy="group-selection-card" class="selection-group-card">
      <ul slot="markant-card__content" class="group-card-content">
        @for (invitationGroup of invitationGroups; track invitationGroup.id) {
          <li>
            <markant-platform-ui-group-selection-item
              [class.disabled]="!invitationGroup.hasSlotsAvailable"
              [group]="invitationGroup"
              [attr.data-cy]="'group-selection-item' + invitationGroup.id"
              [checked]="
                invitationGroupsSelected | isGroupSelected: invitationGroup.id
              "
              (clicked)="clicked.emit(invitationGroup)"
            ></markant-platform-ui-group-selection-item>
          </li>
        }
      </ul>
    </div>
  </div>

  <div class="groups-assigned">
    <h5 class="group-title">
      {{ 'organization.users.invite.groupView.groupsAssigned' | transloco }}
    </h5>

    <div class="groups-assigned-content">
      @for (
        invitationGroupSelected of invitationGroupsSelected;
        track invitationGroupSelected.id
      ) {
        <markant-platform-ui-group-assigned-with-variants-item
          [invitationGroup]="invitationGroupSelected"
          [attr.data-cy]="'groups-assigned-card-' + invitationGroupSelected.id"
        ></markant-platform-ui-group-assigned-with-variants-item>
      } @empty {
        <div class="no-service-roles-container">
          <p class="no-service-role-assigned">
            {{
              'organization.users.invite.groupView.noGroupSelected.noGroupSelectedTitle'
                | transloco
            }}
          </p>
          <p class="no-service-role-assigned no-service-role-assigned-label">
            {{
              'organization.users.invite.groupView.noGroupSelected.noGroupSelectedLabel'
                | transloco
            }}
          </p>
        </div>
      }
    </div>
  </div>
</div>
